import { IApiGroupMappingType } from '@api/interfaces/data-contracts';
import { IAccountType } from '@components-member/socialTrading/social.interfaces';
import ENUM_TYPES from '@components-shared/enum.types';

interface getFilterParamsOutput {
  filters: { column: string; value: string | null; orGroup: string }[];
  take: number;
}

export const getFilterParams = ({
  filterKeyword,
  investorTypes,
  tradingPlatformType,
  maxAccounts,
}: {
  filterKeyword: string;
  investorTypes: IAccountType[];
  tradingPlatformType?: ENUM_TYPES['TRADING_PLATFORM_TYPE'];
  maxAccounts: number;
}): getFilterParamsOutput => {
  const availableInvestorType = investorTypes.map((item) => item.groupMappingType);

  const standardInvestorType = availableInvestorType.find(
    (item) => item === IApiGroupMappingType.RealCopyTradingInvestorStandard,
  )
    ? IApiGroupMappingType.RealCopyTradingMasterStandard
    : null;

  const ecnInvestorType = availableInvestorType.find((item) => item === IApiGroupMappingType.RealCopyTradingInvestorEcn)
    ? IApiGroupMappingType.RealCopyTradingMasterEcn
    : null;

  const defaultFilters = [
    { column: 'nickname', value: filterKeyword, orGroup: 'group1' },
    { column: 'login', value: filterKeyword, orGroup: 'group1' },
    { column: 'groupMappingType', value: standardInvestorType, orGroup: 'group2' },
    { column: 'groupMappingType', value: ecnInvestorType, orGroup: 'group2' },
  ];

  if (tradingPlatformType) {
    defaultFilters.push({ column: 'tradingPlatformType', value: tradingPlatformType, orGroup: 'group3' });
  }

  const take = maxAccounts;
  const filters = defaultFilters.filter((item) => item.value !== null);

  return { filters, take };
};
